import { getService } from './service';

export const getAddressDetails = (ptsAddressID) => {
  const service = getService('ptsaddress');
  return service.find({ query: { ptsAddressID } });
};

export const getAddressCoordinates = (ptsCoordinateID) => {
  const service = getService('cad-address-coordinates');
  return service.get(ptsCoordinateID);
};

export const getPrePlanDetails = (ptsAddressID) => {
  const service = getService('cad-address-pre-plan');
  return service.get(ptsAddressID);
};

export const checkMergeStats = async (ptsAddressID) => {
  const service = getService('cad-address-merge');
  return await service.find({ query: { ptsAddressID } });
};

export const addressMerge = async (data) => {
  const service = getService('cad-address-merge');
  return await service.create(data);
};
